import { useState } from 'react';
import './Scoreboard.css';

const ScoreElement = ({ background }) => {
    const [score, setScore] = useState(0);
    
    const updateScore = (diff) => {
        setScore(score + diff);
    }

    return (
        <div className='score-container'>
            <div className={ background === "even" ? 'scorecard scorecard-even' : 'scorecard'}>
                <span>{score}</span>
            </div>
            <div className='score-controls'>
                <span onClick={() => updateScore(1)}>+</span>
                <span onClick={() => updateScore(-1)}>-</span>
                <span onClick={() => updateScore(2)}>+2</span>
                <span onClick={() => updateScore(3)}>+3</span>
                <span onClick={() => updateScore(4)}>+4</span>
            </div>
        </div>
    );
};

export default function ScoreBoard() {
    return (
        <div className='scores-container'>
            <ScoreElement />
            <ScoreElement background="even"/>
        </div>
    );
}